import { createContext } from 'react';
import { ThemeProviderState } from './types';

const initialState: ThemeProviderState = {
  theme: 'system',
  setTheme: () => {},
  systemTheme: 'dark', // or "dark", based on your default
  effectiveTheme: 'dark',
};

export const ThemeProviderContext =
  createContext<ThemeProviderState>(initialState);
